document.addEventListener('DOMContentLoaded' , () => {

    // Logic collapse footer labels
    if(document.body.clientWidth <= 994){
        const blocksFooter = document.querySelectorAll('.footer-block');
        [...blocksFooter].map(block => {
            const blocksFooterHeading = block.children[0];
            const blocksFooterContent = block.querySelector('.footer-block__details-content');
            blocksFooterHeading.addEventListener('click' , (e) => {
                e.target?.classList.toggle('active');
                blocksFooterContent?.classList.toggle('active');
            })
        });
    }

    // Logic gift card
    window.addEventListener('SCE:change', (e) => {
        (async function(){
    
            try{
                const getCart = await fetch('/cart.js');
                const cart = await getCart.json();
                const cartDrawerAdded = document.querySelector('cart-drawer-items, cart-drawer-test-items');
                const giftProductList = cart.items.filter(item => item.properties.gift)


                if(giftProductList.length == 1){
                    const giftProductIdx = cart.items.findIndex(item => item.handle.includes('regalo'));
                    cartDrawerAdded.updateQuantity(giftProductIdx + 1, 0)
                }

            }catch(error){
                console.error(error.message)
            }
        }())
    });
})


document.addEventListener('StartAsyncLoading',function(event){
document.querySelectorAll('.video-wrapper').forEach((ele) => {
    ele.querySelector('video').load();
});
});

document.querySelectorAll('.video-wrapper').forEach((ele) => {
    //console.log(ele);
    ele.addEventListener('click', function() {
        if(this.classList.contains('is-playing')) {    
        this.querySelector('video').pause();
        }
        else {
        document.querySelectorAll('.video-wrapper').forEach((ele) => {
            ele.querySelector('video').pause();
        });
        this.classList.add('is-playing');
        this.querySelector('video').play();
        }
    })
    ele.querySelector('video').addEventListener('ended', function() {
        this.closest('.video-wrapper').classList.remove('is-playing');
    })
    ele.querySelector('video').addEventListener('pause', function() {
        //console.log(this);
        this.closest('.video-wrapper').classList.remove('is-playing');
    })
})